import compatibilityData from '../config/contextCompatibility.json';

class HelperContext {

	static getCustomerMarket(clientType) {
		switch (clientType) {
			case ('COLL'):
				return 'B2E';
			case ('EMPL'):
				return 'B2E';
			case ('E'):
				return 'B2B';
			case ('P'):
				return 'B2C';
			default:
				return 'none';

		}
	}
	
	static updateMinDecimalFractionDigits(propsFormat, argName, country) {
		if (argName === 'apr' && country === 'GB') {
			propsFormat.minimumFractionDigits = 1;
		}
		else {
			propsFormat.minimumFractionDigits = 2;
		}
	}

	static getCountries(perimeterFilter) {
		const countries = compatibilityData.allCountries;
		if (compatibilityData.perimeterCountryCompability[perimeterFilter] != null) {
			return compatibilityData.perimeterCountryCompability[perimeterFilter];
		}
		return countries;
	}
	static getAppliedCountry(currentCountry, perimeterFilter) {
		const countries = HelperContext.getCountries(perimeterFilter);
		if (!countries.includes(currentCountry)) {
			return countries[0];
		}
		return currentCountry;
	}

	static getDefaultLangage(country) {
		if (compatibilityData.countryLangageCompatibility[country] != null) {
			return compatibilityData.countryLangageCompatibility[country][0];
		} else {
			return null;
		}
	}

	static getCompatibleLanguages(country) {
		return compatibilityData.countryLangageCompatibility[country];
	}

	static getDistributionBrands(perimeterFilter, country) {
		let distributionBrands = compatibilityData.allDistributionBrands;
		if (perimeterFilter.length === 0) {
			return distributionBrands;
		}
		if (country != null && compatibilityData.countryBrandCompatibility[country] != null) {
			const setData = new Set(compatibilityData.countryBrandCompatibility[country]);
			distributionBrands = distributionBrands.filter(x => setData.has(x));
		}
		return distributionBrands;
	}
	static getAppliedDistributionBrand(currentDistributionBrand, country, perimeterFilter) {
		const distributionBrands = HelperContext.getDistributionBrands(perimeterFilter, country);
		if (!distributionBrands.includes(currentDistributionBrand)) {
			return distributionBrands[0];
		}
		return currentDistributionBrand;
	}
	static getDistributionBrandSections(perimeterFilter, country) {
		const distributionBrandSections = compatibilityData.distributionBrandSections;
		if (perimeterFilter.length === 0) {
			return distributionBrandSections;
		}
		const distributionBrands = HelperContext.getDistributionBrands(perimeterFilter, country);
		const resultingDistributionBrandSections = {};
		for (const brandSection in distributionBrandSections) {
			const brands = [];
			for (const brandKey in distributionBrandSections[brandSection]) {
				const brand = distributionBrandSections[brandSection][brandKey];
				if (distributionBrands.includes(brand)) {
					brands.push(brand);
				}
			}
			if (brands.length > 0) {
				resultingDistributionBrandSections[brandSection] = brands;
			}
		}
		return resultingDistributionBrandSections;
	}

	static getSiteCodes(perimeterFilter, vehDescType, country, distributionBrand) {
		let siteCodes = compatibilityData.allSiteCodes;
		if (perimeterFilter.length === 0) {
			return siteCodes;
		}
		if (vehDescType != null && compatibilityData.vehDescTypeSiteCodeCompatibility[vehDescType] != null) {
			const setData = new Set(compatibilityData.vehDescTypeSiteCodeCompatibility[vehDescType]);
			siteCodes = siteCodes.filter(x => setData.has(x));
		}
		for (const siteCode in compatibilityData.siteCodeBrandCompatibility) {
			if (siteCodes.includes(siteCode) && !compatibilityData.siteCodeBrandCompatibility[siteCode].includes(distributionBrand)) {
				const index = siteCodes.indexOf(siteCode);
				siteCodes.splice(index, 1);
			}
		}
		for (const siteCode in compatibilityData.siteCodeCountryCompatibility) {
			if (siteCodes.includes(siteCode) && !compatibilityData.siteCodeCountryCompatibility[siteCode].includes(country)) {
				const index = siteCodes.indexOf(siteCode);
				siteCodes.splice(index, 1);
			}
		}
		for (const siteCode in compatibilityData.siteCodeCountryBrandCompatibility) {
			if (siteCodes.includes(siteCode) && compatibilityData.siteCodeCountryBrandCompatibility[siteCode][country] != null
				&& !compatibilityData.siteCodeCountryBrandCompatibility[siteCode][country].includes(distributionBrand)) {
				const index = siteCodes.indexOf(siteCode);
				siteCodes.splice(index, 1);
			}
		}
		return siteCodes;
	}
	static getAppliedSiteCode(currentSiteCode, perimeterFilter, vehDescType, country, distributionBrand) {
		const siteCodes = HelperContext.getSiteCodes(perimeterFilter, vehDescType, country, distributionBrand);
		if (!siteCodes.includes(currentSiteCode)) {
			return siteCodes[0];
		}
		return currentSiteCode;
	}
	static getSiteCodeSections(perimeterFilter, vehDescType, country, distributionBrand) {
		const siteCodeSections = compatibilityData.siteCodeSections;
		if (perimeterFilter.length === 0) {
			return siteCodeSections;
		}
		const siteCodes = HelperContext.getSiteCodes(perimeterFilter, vehDescType, country, distributionBrand);
		const resultingSiteCodeSections = {};
		for (const siteCodeSection in siteCodeSections) {
			const siteCodesBuild = [];
			for (const key in siteCodeSections[siteCodeSection]) {
				const siteCode = siteCodeSections[siteCodeSection][key];
				if (siteCodes.includes(siteCode)) {
					siteCodesBuild.push(siteCode);
				}
			}
			if (siteCodesBuild.length > 0) {
				resultingSiteCodeSections[siteCodeSection] = siteCodesBuild;
			}
		}
		return resultingSiteCodeSections;
	}

	static getJourneyTypes(perimeterFilter, customerType, siteCode) {
		let journeyTypes = compatibilityData.allJourneyTypes;
		if (perimeterFilter.length === 0) {
			return journeyTypes;
		}
		if (siteCode != null && compatibilityData.siteJourneyCompatibility[siteCode] != null) {
			journeyTypes = compatibilityData.siteJourneyCompatibility[siteCode];
		}
		if (customerType != null && compatibilityData.customerTypeJourneyTypeCompatibility[customerType] != null) {
			const setData = new Set(compatibilityData.customerTypeJourneyTypeCompatibility[customerType]);
			journeyTypes = journeyTypes.filter(x => setData.has(x));
		}
		return journeyTypes;
	}
	static adjustJourneyType(perimeterFilter, customerType, siteCode, currentJourneyType) {
		const journeyTypes = HelperContext.getJourneyTypes(perimeterFilter, customerType, siteCode);
		if (journeyTypes != null && !journeyTypes.includes(currentJourneyType)) {
			return journeyTypes[0];
		}
		return currentJourneyType;
	}
}
export default HelperContext


